import { LinkPostInput } from '../../templates/inputs/LinkPostInput';
import {
    DEFAULT_OPEN_LOCATION_ACTION,
    getDefaultButton,
} from '../components/ActionButton';
import { ArticlePage } from '../components/ArticlePage';
import { isArticlePost } from '../PostTypes';
import { ArticlePostData } from '../types/ArticlePostType';
import { defineTemplate } from './TemplateUtils';

import { RequiredField } from '../../../types/requiredField';

export type LinkPage = RequiredField<ArticlePage, 'button'>;
export type LinkPostData = Omit<ArticlePostData, 'pages'> & {
    pages: [LinkPage];
};

export const isLinkPage = (value: ArticlePage): value is LinkPage => {
    return value.button !== undefined;
};

export const isLinkPost = (value: unknown): value is LinkPostData => {
    return (
        isArticlePost(value) &&
        value.pages.length === 1 &&
        isLinkPage(value.pages[0])
    );
};

export const LinkMedium = defineTemplate(
    'Article',
    'Medium',
    LinkPostInput,
    () =>
        ({
            $type: 'Article',
            size: 'Medium',
            pages: [
                {
                    button: getDefaultButton(DEFAULT_OPEN_LOCATION_ACTION),
                },
            ],
        }) satisfies LinkPostData,
    isLinkPost,
);
export const LinkLarge = defineTemplate(
    'Article',
    'Large',
    LinkPostInput,
    () =>
        ({
            $type: 'Article',
            size: 'Large',
            pages: [
                {
                    button: getDefaultButton(DEFAULT_OPEN_LOCATION_ACTION),
                },
            ],
        }) satisfies LinkPostData,
    isLinkPost,
);
